import React, { useEffect, useState } from 'react';
import Cards from '../../Components/1st page/Cards';
import Section2 from '../../Components/1st page/Section2';
import Section3 from '../../Components/1st page/Section3';
import SimpleSliderSection from '../../Components/1st page/Section4';
import Section5 from '../../Components/1st page/Section5';
import Accordion from '../../Components/1st page/accordian';
import Header from '../../Components/1st page/Header';
import Footer from '../../Components/1st page/Footer';
import StaffSection from '../../Components/1st page/StaffSection';
import StudentResults from '../../Components/1st page/StudentResults';
import RecruitersSection from '../../Components/1st page/RecruitersSection';
import logo from '../../Assets/EMEI logo.jpeg';
import './HomePage.css';

export default function HomePage() {
  const [loaderState, setLoaderState] = useState("loading");
  const showLoader = loaderState !== "done";

  useEffect(() => {
    const exitTimer = window.setTimeout(() => {
      setLoaderState("exiting");
    }, 1000);

    const removeTimer = window.setTimeout(() => {
      setLoaderState("done");
    }, 1450);

    return () => {
      window.clearTimeout(exitTimer);
      window.clearTimeout(removeTimer);
    };
  }, []);

  return (
    <>
    {showLoader && (
      <div className={`home-page-loader home-page-loader--${loaderState}`} role="status" aria-live="polite" aria-label="Loading EMEI home page">
        <div className="home-page-loader__panel">
          <div className="home-page-loader__mark" aria-hidden="true">
            <span className="home-page-loader__ring"></span>
            <img src={logo} alt="" className="home-page-loader__logo" />
          </div>
          <div className="home-page-loader__content">
            <span className="home-page-loader__eyebrow">EMEI</span>
            <h1>Welcome to EMEI</h1>
            <p className="home-page-loader__description">Loading your campus experience</p>
            <div className="home-page-loader__bar" aria-hidden="true">
              <span></span>
            </div>
          </div>
        </div>
      </div>
    )}
    <main inert={loaderState === "loading"} aria-busy={loaderState === "loading"} className={`home-page-shell ${loaderState !== "loading" ? "home-page-shell--ready" : ""}`}>
      <Header key={loaderState === "loading" ? "loading" : "ready"}/>
        <Cards />
        <Section2 />
        <Section3 />
        <SimpleSliderSection />
        <StaffSection />
        <StudentResults />
        <Section5 />
        <RecruitersSection />
        <Accordion />
        <Footer />
    </main>
    </>
  );
}
